import { useQuery } from '@tanstack/react-query';
import { apiGetMVRRequestStatus } from 'api';

export const useMvrRequestStatus = (mvrOrderId: number | null) => {
  const { data, isLoading } = useQuery({
    queryKey: ['mvr-request-status', mvrOrderId],
    queryFn: () => apiGetMVRRequestStatus(mvrOrderId as number),
    enabled: mvrOrderId != null,
    refetchInterval: (query) =>
      query.state.data?.status === 'in_progress'
        ? query.state.data.polling_interval * 1000
        : false,
  });

  return { status: data, isLoading };
};
